import React from 'react';
import HotTopicSeeMoreCategory from '../../hotTopic/HotTopicSeeMoreCategory';

// Studio-only see-all / tag listing. Clicking a pack always opens the studio editor.
const HotTopicStudioSeeMore: React.FC<any> = props => <HotTopicSeeMoreCategory {...props} forceStudioMode />;

export default HotTopicStudioSeeMore;
